'use strict';
import SharedStatusService from './SharedStatusService';
import SharedClientService from './SharedClientService';

export var sharedStatusService = new SharedStatusService();
export var sharedClientService = new SharedClientService();
